/* VIATRIX v37: favoritas a passar sozinhas + fotos do conjunto a rodar */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  if (reduce) return;

  /* Favoritas (página inicial): avança 1 peça a cada 3,2 s; para quando a cliente mexe */
  document.querySelectorAll('.vx-home .vx-rail--products[data-vx-rail]').forEach((rail) => {
    if (rail.dataset.vx37Auto) return;
    rail.dataset.vx37Auto = '1';
    let timer = null, pausedUntil = 0, visible = false;
    const step = () => {
      if (!visible || Date.now() < pausedUntil || document.hidden) return;
      const card = rail.firstElementChild;
      if (!card) return;
      const gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap) || 0;
      const w = card.getBoundingClientRect().width + gap;
      const atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 8;
      rail.scrollTo({ left: atEnd ? 0 : rail.scrollLeft + w, behavior: 'smooth' });
    };
    const pause = (ms) => { pausedUntil = Date.now() + ms; };
    ['pointerdown', 'touchstart', 'wheel'].forEach((ev) => rail.addEventListener(ev, () => pause(9000), { passive: true }));
    if (fine) { rail.addEventListener('mouseenter', () => pause(1e9)); rail.addEventListener('mouseleave', () => pause(1500)); }
    const sec = rail.closest('section') || rail;
    sec.querySelectorAll('.vx-nav__b').forEach((b) => b.addEventListener('click', () => pause(9000)));
    if ('IntersectionObserver' in window) {
      new IntersectionObserver((es) => es.forEach((e) => { visible = e.intersectionRatio > 0.35; }), { threshold: [0, 0.35, 0.6] }).observe(rail);
    } else visible = true;
    timer = setInterval(step, 3200);
  });

  /* Conjunto: foto da modelo → colar → pulseira, a rodar */
  document.querySelectorAll('[data-vx37-fade]').forEach((box) => {
    const imgs = [...box.querySelectorAll('.vx37-bd__img')];
    const dots = [...box.querySelectorAll('.vx37-bd__dots i')];
    if (imgs.length < 2) return;
    dots.forEach((d, k) => { if (k >= imgs.length) d.remove(); });
    let i = 0, t = null, visible = false;
    const show = (k) => {
      i = (k + imgs.length) % imgs.length;
      imgs.forEach((im, j) => im.classList.toggle('is-on', j === i));
      box.querySelectorAll('.vx37-bd__dots i').forEach((d, j) => d.classList.toggle('is-on', j === i));
    };
    const restart = () => { clearInterval(t); t = setInterval(() => { if (visible && !document.hidden) show(i + 1); }, 3000); };
    let x0 = null;
    box.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    box.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 35) { show(i + (dx < 0 ? 1 : -1)); restart(); }
      x0 = null;
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver((es) => es.forEach((e) => { visible = e.isIntersecting; }), { threshold: 0.3 }).observe(box);
    } else visible = true;
    restart();
  });
})();
